import ActionTypes from '../constants/ActionTypes';

const getOrCreateDampingCoefficient = (pointSystemId) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_GET_OR_CREATE,
  payload: {
    pointSystemId,
  },
});

getOrCreateDampingCoefficient.success = (item) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_GET_OR_CREATE__SUCCESS,
  payload: {
    item,
  },
});

getOrCreateDampingCoefficient.failure = (pointSystemId, error) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_GET_OR_CREATE__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const fetchDampingCoefficients = (pointSystemId) => ({
  type: ActionTypes.DAMPING_COEFFICIENTS_FETCH,
  payload: {
    pointSystemId,
  },
});

fetchDampingCoefficients.success = (pointSystemId, items) => ({
  type: ActionTypes.DAMPING_COEFFICIENTS_FETCH__SUCCESS,
  payload: {
    pointSystemId,
    items,
  },
});

fetchDampingCoefficients.failure = (pointSystemId, error) => ({
  type: ActionTypes.DAMPING_COEFFICIENTS_FETCH__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const createDampingCoefficient = (pointSystemId) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_CREATE,
  payload: {
    pointSystemId,
  },
});

createDampingCoefficient.success = (item) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_CREATE__SUCCESS,
  payload: {
    item,
  },
});

createDampingCoefficient.failure = (pointSystemId, error) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_CREATE__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const updateDampingCoefficient = (id, data) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_UPDATE,
  payload: {
    id,
    data,
  },
});

updateDampingCoefficient.success = (item) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateDampingCoefficient.failure = (id, error) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteDampingCoefficient = (id) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_DELETE,
  payload: {
    id,
  },
});

deleteDampingCoefficient.success = (item) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_DELETE__SUCCESS,
  payload: {
    item,
  },
});

deleteDampingCoefficient.failure = (id, error) => ({
  type: ActionTypes.DAMPING_COEFFICIENT_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

export default {
  getOrCreateDampingCoefficient,
  fetchDampingCoefficients,
  createDampingCoefficient,
  updateDampingCoefficient,
  deleteDampingCoefficient,
};

